import { render } from "./Consult.vue?vue&type=template&id=fd6b677c&scoped=true"
import script from "./Consult.vue?vue&type=script&lang=js"
export * from "./Consult.vue?vue&type=script&lang=js"

import "./Consult.vue?vue&type=style&index=0&id=fd6b677c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd6b677c"]])

export default __exports__